import {DataTableBulkSelectorConfig, RecordedEntryDataTableBulkSelector} from "@/shared/ui/dataTableBulkSelector";
import {ProjectTimeTableSums, ReportProjectTime} from "@/shared/timr";

export class ProjectTimeBulkSelector extends RecordedEntryDataTableBulkSelector<ReportProjectTime> {

	protected durationBillableSum = 0;
	protected durationNotBillableSum = 0;
	protected allSelectedDurationBillableSum = 0;
	protected allSelectedDurationNotBillableSum = 0;

	constructor(public config: DataTableBulkSelectorConfig) {
		super(config);
	}

	protected override sumAdditionalParams(recording: ReportProjectTime, subtract: boolean) {
		if (recording.durationNet) {
			const durationNet = subtract ? -recording.durationNet : recording.durationNet;
			if (recording.billable) {
				this.durationBillableSum += durationNet;
			} else {
				this.durationNotBillableSum += durationNet;
			}
		}
	}

	protected override onRecordDataChanged(recording: ReportProjectTime) {
		super.onRecordDataChanged(recording);
		const old = this.entries.get(recording.id).recording;
		if (old.durationNet !== recording.durationNet) {
			this.sumAdditionalParams(old, true);
			this.sumAdditionalParams(recording, false);
		}
	}

	protected initAllSelectedSum(dataTableJsonData: { projectTimeSums?: ProjectTimeTableSums }) {
		if (dataTableJsonData.projectTimeSums) {
			const projectTimeSums = dataTableJsonData.projectTimeSums;
			const billableBreakMs = projectTimeSums.billableRecordSums.breakTime * 60 * 1000;
			const notBillableBreakMs = projectTimeSums.notBillableRecordSums.breakTime * 60 * 1000;
			this.allSelectedDurationNetSum = (projectTimeSums.billableRecordSums.duration + projectTimeSums.notBillableRecordSums.duration)
				- (billableBreakMs + notBillableBreakMs);
			this.allSelectedDurationBillableSum = projectTimeSums.billableRecordSums.duration - billableBreakMs;
			this.allSelectedDurationNotBillableSum = projectTimeSums.notBillableRecordSums.duration - notBillableBreakMs;
		}
	}

	public override getSums() {
		return {
			...super.getSums(),
			durationBillableSum: this.durationBillableSum,
			durationNotBillableSum: this.durationNotBillableSum
		};
	}

	protected override resetSums() {
		super.resetSums();
		this.durationBillableSum = 0;
		this.durationNotBillableSum = 0;
	}

	protected override setAllSelectedSums() {
		super.setAllSelectedSums();
		this.durationBillableSum = this.allSelectedDurationBillableSum;
		this.durationNotBillableSum = this.allSelectedDurationNotBillableSum;
	}
}
